import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ModelTypeResponse } from "@/types";

type Props = {
  enabled?: boolean;
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
  entity_type?: "patient" | "employee" | "both" | null;
};

async function fetchModelType({
  page,
  per_page,
  search,
  entity_type,
}: Props): Promise<ModelTypeResponse> {
  const pageParams = new URLSearchParams({ page: page || "1", search: search || "" });
  if (per_page) pageParams.set("per_page", String(per_page));
  
  const entityParams = entity_type ? `&entity_type=${entity_type}` : "";
  
  const response = await httpRequest.get<ModelTypeResponse>(
    `/models-types?${pageParams}${entityParams}`
  );
  return response.data;
}

export function useFetchModelTypeQuery(props: Props) {
  const modelTypeQuery = useQuery({
    queryKey: ["models-types", props.entity_type, props.page || "1", props.per_page, props.search],
    enabled: props.enabled,
    queryFn: () => fetchModelType(props),
    keepPreviousData: true,
  });

  return {
    ...modelTypeQuery,
    data: modelTypeQuery.data,
  };
}
